<div class="dialog-select-halls" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div class="title-letter" fxLayout="row" fxLayoutGap="10px">
        <mat-icon>search</mat-icon>
        <span>{{'施設・カテゴリリスト一覧' | translate}}</span>
      </div>

      <button mat-button (click)="onNoClick()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <div class="filter-field" fxLayout="row" fxLayoutGap="20px">
    <mat-form-field fxFlex="25%">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
    </mat-form-field>
  </div>

  <div mat-dialog-content fxLayout="column" fxLayoutAlign="start center" fxFlex="500px" style="overflow: auto;">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef> No. </th>
        <td mat-cell *matCellDef="let paidContent; let i = index">{{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }}</td>
      </ng-container>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <span> {{'選択' | translate}} </span>
        </th>
        <td mat-cell *matCellDef="let row">
          <button mat-stroked-button color="primary" (click)="selectFunc(row)">{{'選択' | translate}}</button>
        </td>
      </ng-container>

      <ng-container matColumnDef="hall_id">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let hall"> {{ hall.hall_id }} </td>
      </ng-container>

      <ng-container matColumnDef="show_paid_content">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'有償コンテンツ' | translate}} </th>
        <td mat-cell *matCellDef="let hall"> 
          <ng-container *ngIf="!!hall.show_paid_content">
            <mat-icon>movie</mat-icon>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'名称' | translate}} </th>
        <td mat-cell *matCellDef="let hall"> {{ hall.hall_names | multiName:projectLanguages:projectBaseLang }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator class="page" [pageSizeOptions]="[15, 30, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
</div>
